import {
  type QuarterlyForecastClinkerProductionHierarchy,
  formatDateUtcToTimezoneDateOnly,
  PERFORMANCE_KPI_REQUEST_STALE_TIME
} from '@domain/kpis'
import {ApiClient} from '@hconnect/apiclient'
import {Iso8601} from '@hconnect/uikit'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {isEmpty} from 'lodash'

import {mapClinkerProductionQuarterlyDataDto} from '../../mappers'

export const useClinkerProductionQuarterly = (
  timestamp: Iso8601,
  timezone: string,
  locationId?: string,
  options?: Omit<
    UseQueryOptions<QuarterlyForecastClinkerProductionHierarchy | null, AxiosError>,
    'queryKey' | 'queryFn'
  >
) => {
  const referenceDate = formatDateUtcToTimezoneDateOnly(timestamp, timezone)

  return useQuery<QuarterlyForecastClinkerProductionHierarchy | null, AxiosError>({
    queryKey: ['clinker-production-quarterly', referenceDate, locationId],
    queryFn: async ({signal}) => {
      if (!locationId) return Promise.resolve(null)

      const response =
        await ApiClient.axiosInstance.get<QuarterlyForecastClinkerProductionHierarchy>(
          '/kpi/dashboard/clinker-production-qf',
          {
            params: {locationId, timestamp: referenceDate},
            signal
          }
        )
      return response.data
    },
    select: (data) => {
      return data && !isEmpty(data) ? mapClinkerProductionQuarterlyDataDto(data) : null
    },
    staleTime: PERFORMANCE_KPI_REQUEST_STALE_TIME,
    ...options
  })
}
